import React from 'react'
import { IUiIcon } from '../../../types/ui'

export const IconExternalLink = (
	{
		size = 16,
		imgSize = 16,
		fill = 'black'
	}: IUiIcon
) => {
	return <>
		<svg xmlns="http://www.w3.org/2000/svg"
		     width={`${size}px`}
		     height={`${size}px`}
		     viewBox={`0 0 ${imgSize} ${imgSize}`}
		     fill="none"
		>
			<path fillRule="evenodd" clipRule="evenodd"
			      d="M9.51953 1.52002H13.9995C14.2646 1.52002 14.4795 1.73492 14.4795 2.00002V6.48002H13.5195V3.15876L6.6662 10.0122L5.98738 9.33336L12.8406 2.48002H9.51953V1.52002ZM3.33286 4.48002C3.10655 4.48002 2.8895 4.56992 2.72947 4.72995C2.56944 4.88999 2.47953 5.10703 2.47953 5.33335V12.6667C2.47953 12.893 2.56944 13.1101 2.72947 13.2701C2.8895 13.4301 3.10655 13.52 3.33286 13.52H10.6662C10.8925 13.52 11.1096 13.4301 11.2696 13.2701C11.4296 13.1101 11.5195 12.893 11.5195 12.6667V8.18669H12.4795V12.6667C12.4795 13.1476 12.2885 13.6088 11.9484 13.9489C11.6084 14.289 11.1471 14.48 10.6662 14.48H3.33286C2.85194 14.48 2.39071 14.289 2.05064 13.9489C1.71058 13.6088 1.51953 13.1476 1.51953 12.6667V5.33335C1.51953 4.85243 1.71058 4.3912 2.05064 4.05113C2.39071 3.71107 2.85194 3.52002 3.33286 3.52002H7.81286V4.48002H3.33286Z"
			      fill={fill}
			/>
		</svg>
	</>
}
